module.exports = __webpack_public_path__ + "static/media/lunas.6ba15221.png";